/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import classNames from 'classnames'
import { useTranslation } from 'contexts/Localization'
import { NftID } from 'hooks/setGetListMyNft'
import { useRouter } from 'next/router'
import React, { useCallback } from 'react'
import { NFTItemType } from 'state/nfts/type'

interface BCCPrivilegeProps {
  data: any
}

type TabType = 'first' | 'second' | 'third'

const profileData = {
  first: [
    'Receive daily income from MBC bonus token, 8% per month.',
    'E-BCC holders will start receiving daily MBC rewards 48 hours after acquiring E-BCC.',
    'The vesting period for the full bonus will be completed over 13 months.',
  ],
  second: [
    'E-BCC holders will receive dividends like shareholders, based on Monbase Global’s milestone-based regulations.',
  ],
}

const BCCPrivilege: React.FC<BCCPrivilegeProps> = ({ data }) => {
  console.log('data', data)
  const { query, replace } = useRouter()
  const { t } = useTranslation()

  const tab = query?.tab ?? 'first'

  /**
   * function
   * =================================================================
   */

  const onTabChange = useCallback(
    (value) => {
      replace(
        {
          query: {
            ...query,
            tab: value,
          },
        },
        undefined,
        { scroll: false },
      )
    },
    [replace, query],
  )

  /**
   * render view
   * =================================================================
   */

  /**
   * render view
   * =================================================================
   */

  const renderSingleTab = useCallback(
    (tabIndex: TabType) => {
      return (
        <ul className="list-disc list-outside ps-3 mt-4 flex flex-col gap-2 text-secondary leading-normal">
          {profileData?.[tabIndex]?.map((item) => (
            <li>{t(item)}</li>
          ))}
        </ul>
      )
    },
    [t],
  )

  return (
    <>
      <div className="hidden basis-8/12 lg:grid gap-5 xl:grid-cols-12 flex-1">
        <div className="bg-pale-mint lg:col-span-12 xl:col-span-6 border border-solid stroke-sm rounded-lg">
          <div
            className="flex items-center gap-7 px-10 rounded-t-lg"
            style={{
              background: ` linear-gradient(113deg, #000 -8.58%, #010F28 15.03%, #084EB7 53.36%, #3C8BFF 98.95%, #00F0FF 115.3%)`,
            }}
          >
            <img className="h-14 scale-[2.5]" src="/images/investment/1.png" alt="1" />
            <h1 className="text-text-invert font-bold text-2xl whitespace-nowrap">{t('THE FIRST PRIVILEGE')}</h1>
          </div>

          <div className="p-5">{renderSingleTab('first')}</div>
        </div>

        <div
          className={classNames(
            'bg-pale-mint lg:col-span-12 border border-solid border-stroke-sm rounded-lg xl:col-span-6',
          )}
        >
          <div
            className="flex items-center gap-7 px-10 rounded-t-lg"
            style={{
              background: ` linear-gradient(113deg, #000 -8.58%, #010F28 15.03%, #084EB7 53.36%, #3C8BFF 98.95%, #00F0FF 115.3%)`,
            }}
          >
            <img className="h-14 scale-[2.5]" src="/images/investment/2.png" alt="2" />
            <h1 className="text-text-invert font-bold text-2xl whitespace-nowrap">{t('THE SECOND PRIVILEGE')}</h1>
          </div>

          <div className="p-5">{renderSingleTab('second')}</div>
        </div>

        {!data?.isStaked && (
          <div
            className={classNames(
              'bg-pale-mint lg:col-span-12 border border-solid border-stroke-sm rounded-lg xl:col-span-12',
            )}
          >
            <div className="p-5">{renderSingleTab('third')}</div>
          </div>
        )}
      </div>

      <div className="md:basis-7/12 lg:hidden">
        <TabSelector
          active={tab}
          data={[
            { index: 'first', label: t('First privilege') },
            { index: 'second', label: t('Sec privilege') },
            !data?.isStaked && { index: 'third', label: t('Third privilege') },
          ]}
          onChange={onTabChange}
        />

        <div className="mt-5">{renderSingleTab(tab as TabType)}</div>
      </div>
    </>
  )
}

export default BCCPrivilege

interface TabSelectorProps {
  data: any[]
  active: any
  onChange: (val: any) => void
}

const TabSelector: React.FC<TabSelectorProps> = ({ data, active, onChange }) => {
  const { t } = useTranslation()

  return (
    <div className="flex border-b border-text-secondary border-solid">
      {data?.map((item) => (
        <div
          onClick={() => onChange(item?.index)}
          key={item?.index}
          className={classNames('py-3 cursor-pointer flex-1', {
            'border-b-2 border-solid border-brand-500 dark:border-brand-400': active === item?.index,
          })}
        >
          <p
            className={classNames(
              'text-center',
              active === item?.index ? 'font-bold text-brand-500 dark:text-brand-400' : 'text-secondary',
            )}
          >
            {t(item?.label)}
          </p>
        </div>
      ))}
    </div>
  )
}
